module.exports = __webpack_public_path__ + "img/purple-3-oval-solid.12343011.svg";